<template>
    <section>
        <PageTitle title="Branch Menu" v-bind:crumbs="[{href:'/point_of_sale',title:'Branch Menu'}]"/>
        <div class="wrapper wrapper-content">
            <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                <div class="sk-bounce1"></div>
                <div class="sk-bounce2"></div>
                <div class="sk-bounce3"></div>
            </div>
            <ResturantBranches ref="ResturantBranches" v-bind:selectedBranch="selectedBranch"></ResturantBranches>
            <div class="row" id="main-content" v-if="menu.length > 0">
                <div class="col-md-12">
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-3 category_panel">
                                <div class="theiaStickySidebar">
                                    <div class="panel panel-primary">
                                        <div class="panel-heading">
                                            <b>Menu Categories</b>
                                        </div>
                                        <div class="panel-body" id="menu category_nav_bar">
                                            <ul class="nav">
                                                <li><a href="#most_popular">Most Popular</a></li>
                                                <li v-for="(category, index) in menu" v-if="!category.deleted"
                                                    v-bind:key="index+'cat_sidebar'">
                                                    <a v-bind:href="'#' + category.name.replace(/[ /]/g, '')"
                                                       v-bind:title="category.name"
                                                       v-bind:class="(category.name.length > 17) ? 'myTip link' : 'link'">{{
                                                            (category.name.length > 17) ? category.name.substring(0, 17) + '...' : category.name
                                                        }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="panel panel-primary">
                                    <div class="panel-heading">
                                        <b>Items</b>
                                    </div>
                                    <div class="panel-body">
                                        <section>
                                            <h3 id="most_popular" class="text-success"><b>Most Popular</b></h3>
                                            <ul class="list-group">
                                                <template v-for="(mCategory) in menu">
                                                    <li class="list-group-item list-group-item-info"
                                                        v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById"
                                                        v-if="menuItem.mostPopular && !menuItem.deleted"
                                                        v-bind:key="indexMenuItem+'_popular_'+menuItem.name">
                                                        <div class="row">
                                                            <div class="col-md-5">
                                                                <b>{{ menuItem.name }}</b>&emsp;
                                                                <p>{{ menuItem.description }}</p>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <div class="switch ">
                                                                    <div class="onoffswitch">
                                                                        <input type="checkbox" @change="toggleMenuItem(menuItem.id, $event)" :checked="!menuItem.deleted" class="onoffswitch-checkbox" :id="menuItem.id">
                                                                        <label class="onoffswitch-label" :for="menuItem.id">
                                                                            <span class="onoffswitch-inner"></span>
                                                                            <span class="onoffswitch-switch"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>                                                            
                                                            <div class="col-md-5">
                                                                <table
                                                                    class="menu_table hideTableBottom table table-hover">
                                                                    <tbody>
                                                                    <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById"
                                                                        v-bind:key="indexMenuItemType+'type_popular'"
                                                                        v-if="!menuItemType.deleted">
                                                                        <td>{{ menuItemType.serving }}</td>
                                                                        <td class="text-center">{{ menuItemType.price }}
                                                                            Rs.
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </template>
                                            </ul>
                                        </section>
                                        <section v-for="(mCategory, index) in menu" v-if="!mCategory.deleted"
                                                 v-bind:key="index+'cat_main_menu'">
                                            <h3 v-bind:id="mCategory.name.replace(/[ /]/g, '')" class="text-success"><b>{{
                                                    mCategory.name
                                                }}</b>
                                            </h3>
                                            <ul class="list-group">
                                                <li class="list-group-item list-group-item-info"
                                                    v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById"
                                                    
                                                    v-bind:key="indexMenuItem+'item_main_menu'">
                                                    <div class="row">
                                                        <div class="col-md-5">
                                                            <b>{{ menuItem.name }}</b>
                                                            <p>{{ menuItem.description }}</p>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="switch ">
                                                                <div class="onoffswitch">
                                                                    <input type="checkbox" @change="toggleMenuItem(menuItem.id, $event)" :checked="!menuItem.deleted" class="onoffswitch-checkbox" :id="menuItem.id">
                                                                    <label class="onoffswitch-label" :for="menuItem.id">
                                                                        <span class="onoffswitch-inner"></span>
                                                                        <span class="onoffswitch-switch"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <table class="menu_table hideTableBottom table table-hover">
                                                                <tbody>
                                                                <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById"
                                                                    v-if="!menuItemType.deleted"
                                                                    v-bind:key="indexMenuItemType+'type_main_menu'">
                                                                    <td>{{ menuItemType.serving }}</td>
                                                                    <td class="text-center">{{ menuItemType.price }}
                                                                        Rs.
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import PageTitle from "../components/layout_components/PageTitle";
import ResturantBranches from "../components/pos/ResturantBranches";

export default {
    name: "Menu",
    components: {
        PageTitle,
        ResturantBranches
    },
    data: function () {
        return {
            selectedBranch: [],
            isHideSpinner: "hide",
            menu: [],
            selectedTable: {
                id: 0,
                status: "",
                name: ""
            },
        }
    },
    updated: function () {
        $('.category_panel').theiaStickySidebar({
            additionalMarginTop: 20,
            containerSelector: "#main-content"
        });
        let $body   = $(document.body);
        let navHeight = $('.category_panel').outerHeight(true) + 10;
        $body.scrollspy({
            target: '.category_panel',
            offset: navHeight
        });
    },
    methods: {
        fetchBranchTables: function () { //fetch all the tabells
        },
        toggleMenuItem: async function(menuItemId, e){
            let params= new URLSearchParams();
            params.append("deleted", !e.target.checked);
            params.append("branch_id", this.selectedBranch.id);
            this.isHideSpinner=""
            const resp= await this.$http.put(this.$store.state.mainAppURL + "restaurants/toggle_menu_item/" + menuItemId, params).catch( ex => {
              this.showErrorMessage(ex);
            })
            this.isHideSpinner="hide"
            
        }
    }
}
</script>

<style scoped>

</style>
